import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'
const themeV2 = {
  mode: 'light',
  color: {
      primary: {
        main: '#061240', 
        dark: '#030A26', 
        light: '#0C2483',
        contrast: {
          main: '#FFFFFF',
          dark: '#FFFFFF', 
          light: '#FFFFFF'
        }
      },
      secondary: {
        main: '#D78730', 
        dark: '#D78730', 
        light: '#FFE600',
        contrast: {
          main: '#061240', 
          dark: '#061240',
          light: '#061240'
        }
      },
      error: {
        main: '#DF1D1D', 
        dark: '#DF1D1D', 
        light: '#F7E6EA', 
        contrast: {
          main: '#FFFFFF',
          dark: '#FFFFFF',
          light: '#DF1D1D'
        }
      },
      warning: {
        main: '#FBB13C', 
        dark: '#FBB13C',
        light: '#FEF7EB', 
        contrast: {
          main: '#FFFFFF',
          dark: '#FFFFFF',
          light: '#FBB13C'
        }
      },
      success: {
        main: '#29D261',
        dark: '#29D261',
        light: '#F3FBF4',
        contrast: {
          main: '#FFFFFF',
          dark: '#FFFFFF',
          light: '#29D261'
        }
      },
      system: {
        main: '#F2F4F8',
        contrast: {
          main: '#061240'
        } 
      },
      base: {
        black: '#000000',
        disabled: '#DFDFDF',
        gray: {
          primary: '#5F5F61',
          secondary: '#AFBCD5',
          dark: '#7E92B8',
          light: '#E7ECF7',
          button: '#F2F4F8'
        },
        blue: {
          light: '#F3F9FE'
        },
        white: '#FFFFFF',
        switch: {
          default: '#DFDFDF',
          primary: '#7ED321',
          day: '#F9DA56',
          night: '#061240',
          disabled: {
            on: '#CBEDA6',
            off: '#F2F2F2'
          }
        },
        border: '#ECF0F7',
        boxShadow:'#ACD9FB',
        scrollbar: '#062B7533',
        button: {
          border: {
            focus: '#3257EC'
          }, 
          background: {
            pressed: '#EDF1FD'
          }
        }
      },
      background: {
        light: {
          blue: '#F8FBFE',
          gray: '#FAFBFC'
        }
      }
  }
}

const buttonStyles =  {
  '& .button, &.button': {
    background: `${themeV2.color.primary.main} !important`,
    color: `${themeV2.color.primary.contrast.main} !important`,
    '&:hover': {
      background: `${themeV2.color.primary.light} !important`,
      filter: 'none !important'
    },
    '&:focus': {
      background: `${themeV2.color.primary.main} !important`,
      border: `1px solid ${themeV2.color.base.button.border.focus} !important`
    },
    '&:active': {
      border: 0
    }
  }
}

const linkStyles = {
  '& .link': {
    color: `${themeV2.color.primary.main} !important`,
    '&.iconOnly-true': {
      color: 'initial !important'
    },
    '& .loader div': { borderTopColor: themeV2.color.primary.main },
    '&:hover, & a:hover': {
      color: `${themeV2.color.primary.light} !important`,
      filter: 'brightness(120%) !important'
    }
  }
}

const textStyles = {
  '& h2, & label, & .bodycopy p, & .cta p': {
    color: `${themeV2.color.primary.main} !important`
  }
}

const toolTipStyles = {
    // tooltip (override library theme color with custom colors) set on global because this component is rendered on the documents body element
    '.tippy-tooltip': {
      backgroundColor: `${themeV2.color.base.white} !important`,
      color: `${themeV2.color.primary.main} !important`,
      fontSize: pxToEm(16),
      padding: replacePXinStringWithEM('10px 15px'),
      boxShadow: `0px 4px 15px rgba(94, 102, 118, 0.5) !important`,
      borderRadius: pxToEm(12),
  },
  '.tippy-popper[x-placement^=top] [x-arrow]': {
      // borderTopColor: `${themeV2.color.base.white} !important`,
      borderTop: `0 !important`
  },
  '.tippy-popper[x-placement^=bottom] [x-arrow]': {
      // borderBottomColor: `${themeV2.color.base.white} !important`,
      borderBottom: `0 !important`
  },
  '.tippy-popper[x-placement^=left] [x-arrow]': {
      // borderLeftColor: `${themeV2.color.base.white} !important`,
      borderLeft: `0 !important`
  },
  '.tippy-popper[x-placement^=right] [x-arrow]': {
      // borderRightColor: `${themeV2.color.base.white} !important`,
      borderRight: `0 !important`
  }
}
export { themeV2, buttonStyles, linkStyles, textStyles, toolTipStyles }